/** API route map: URLS.Controller.CandidateInterview */
export const CandidateInterview = {
      Name: 'CandidateInterview/',
      GetClientByName: 'get-Client-list-by-name',
      AddCandidateInterview: 'add-candidate-interview',
      GetJobByClientId: 'get-jobs-by-client-id',
      GetCandidateById: 'get-candidate-id',
      GetAllInterview: 'get-candidate-interview',
      DeleteInterview: 'delete',
      PatchInterview: 'patch-interview',
      UpdateCandidateInterview: 'update-candidate-interview',
};
